import { render, staticRenderFns } from "./slurry_period.vue?vue&type=template&id=c79afdd0"
import script from "./slurry_period.vue?vue&type=script&lang=js"
export * from "./slurry_period.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports